import { Environments } from '@content-platform/web-angular-shared-util-configuration';
import { filter, map } from 'rxjs';
import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
const apiEndpoints = {
    applications: '/applications',
    features: '/features',
    roles: '/roles',
    userRoles: '/user-profiles',
    userApplications: '/user-profiles/applications/:uuid',
    userPermissions: '/user-profiles/permissions/:uuid'
};
/**
 * Class with static methods used to get the urls for the api endpoint
 *
 * @export
 * @class ApiParams
 */
export class ApiParams {
    constructor() { }
    /**
     * Gets the full url for the given endpoint/type, incase there are dynamic values in the url
     * the user can pass in tokens to replace them.
     *
     * @static
     * @param type
     * @param [tokens] optional tokens for the url
     * @returns the endpoint full url
     */
    getUrl(type, tokens) {
        let pattern = apiEndpoints[type];
        if (pattern) {
            if (tokens) {
                Object.keys(tokens).forEach((tokenKey) => {
                    const tokenVal = encodeURIComponent(tokens[tokenKey]);
                    const tokenStandIn = ':' + tokenKey;
                    pattern = pattern.replace(tokenStandIn, tokenVal);
                });
            }
            let url = Environments.getUrl('permissionsEndpoint') + pattern;
            console.log('***permissionsEndpoint Url  ', url);
            if (url.endsWith('/')) {
                url = url.slice(0, -1);
            }
            return url;
        }
    }
    /**
     * Gets the full url for the given endpoint/type, incase there are dynamic values in the url
     * the user can pass in tokens to replace them.
     *
     * @static
     * @param type
     * @param [tokens] optional tokens for the url
     * @returns an observable for endpoint full url
     */
    getUrlAsync(type, tokens) {
        return Environments.getUrlAsync('permissionsEndpoint').pipe(filter((res) => !!res), map((endpointUrl) => {
            let url = '';
            let pattern = apiEndpoints[type];
            if (pattern) {
                if (tokens) {
                    Object.keys(tokens).forEach((tokenKey) => {
                        const tokenVal = encodeURIComponent(tokens[tokenKey]);
                        const tokenStandIn = ':' + tokenKey;
                        pattern = pattern.replace(tokenStandIn, tokenVal);
                    });
                }
                url = endpointUrl + pattern;
                if (url.endsWith('/')) {
                    url = url.slice(0, -1);
                }
            }
            console.log('getUrlAsync... url', url);
            return url;
        }));
    }
    static { this.ɵfac = function ApiParams_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ApiParams)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiParams, factory: ApiParams.ɵfac }); }
}
//# sourceMappingURL=api-params.js.map